import { useContext } from "react";
import { TenantContext } from "../context/TenantContext";
import type { TenantConfig, EntityTypeConfig } from "../api/types";

export function useTenantConfig(): {
  config: TenantConfig | null;
  entityTypes: EntityTypeConfig[];
  isLoading: boolean;
  error: string | null;
  getEntityType: (key: string) => EntityTypeConfig | undefined;
} {
  const { config, isLoading, error } = useContext(TenantContext);
  const entityTypes = config?.entity_types ?? [];

  function getEntityType(key: string) {
    return entityTypes.find((et) => et.key === key);
  }

  return { config, entityTypes, isLoading, error, getEntityType };
}
